__webpack_require__.p = "https://webid.cdn.garenanow.com/assets/anniversary.df.garena.co.id/";